import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from '@godaddy/react-mintl';
import ApplicationFooter from '@ux/application-footer';
import '@ux/application-footer/styles';

import './AccountInfoFooter.css';

const AccountInfoFooter = ({ market, privateLabelId, urls, features }) => {
  const { formatMessage } = useIntl();

  return (
    <ApplicationFooter
      messages={{
        'PC:AppHeader:Footer:CopyrightPL': formatMessage({ id: 'PC:AppHeader:Footer:CopyrightPL' }),
        'PC:AppHeader:Footer:Copyright': formatMessage({ id: 'Footer:Copyright' }),
        'PC:AppHeader:Footer:PrivacyPolicy': formatMessage({ id: 'Footer:PrivacyPolicy' }),
        'Shared:Footer:Privacy:DoNotSell': formatMessage({ id: 'Privacy:DoNotSell' })
      }}
      market={ market }
      privateLabelId={ privateLabelId }
      urls={ urls }
      features={ features }
    />
  );
};

AccountInfoFooter.propTypes = {
  market: PropTypes.string,
  privateLabelId: PropTypes.number,
  urls: PropTypes.shape({}),
  features: PropTypes.shape({})
};

export default AccountInfoFooter;
